<template>
  <div>
    <button
      class="FormButton"
      type="button"
      v-if="!isLoading"
      @click="$emit('click')"
      :class="{ full: full }"
    >
      {{ $t(label) }}
    </button>
    <Loader v-else v-bind:text="$t(loadingText)"></Loader>
  </div>
</template>

<script>
import Loader from './Loader'

export default {
  name: 'ValidateFormButton',
  props: {
    label: {
      type: String,
      default: 'forms.default-cta'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: true
    },

    loadingText: {
      type: String,
      default: 'global.loading'
    }
  },
  components: {
    Loader
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/_variables.scss';

.FormButton {
  display: block;
  padding: 10px 5px;
  height: 40px;
  width: 150px;
  border-radius: 10px;
  margin-bottom: 14px;
  color: $primary;
  border: solid 2px $primary;
  font-weight: 500;
  font-size: 0.8rem;
  cursor: pointer;
}

.full {
  border: none;
  background-color: $primary;
  color: $font-button;
}

.ValidateFormButton-Purple button {
  background-color: $primary !important;
}
@media (max-width: 620px) {
  .FormButton {
    margin-bottom: 4px;
  }
}
</style>
